import React from 'react';
interface ReadinessRingProps {
  score: number;
  size?: number;
  label?: string;
  className?: string;
}
function ringColor(score: number): string {
  if (score >= 75) return '#0A5338'; // forest-green
  if (score >= 50) return '#D97706'; // amber-600
  return '#DC2626'; // red-600
}
export function ReadinessRing({
  score,
  size = 96,
  label = 'Readiness',
  className = ''
}: ReadinessRingProps) {
  const stroke = Math.max(6, size * 0.08);
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, score));
  const offset = circumference - clamped / 100 * circumference;
  const color = ringColor(clamped);
  return <div className={`inline-flex flex-col items-center ${className}`} data-id="element-2558" data-mp="2mmt4u2ker5jk">
      <div className="relative" style={{
      width: size,
      height: size
    }} data-id="element-2559" data-mp="2mp5vd448eo88">
        <svg width={size} height={size} className="-rotate-90" role="img" aria-label={`${label} ${clamped} out of 100`} data-id="element-2560" data-mp="168074g4l00qb">
          <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#E5E7EB" strokeWidth={stroke} data-id="element-2561" data-mp="1b5tehchmf0s6" />
          <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={offset} style={{
          transition: 'stroke-dashoffset 0.6s ease'
        }} data-id="element-2562" data-mp="1ky8qrt8clbsd" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-2563" data-mp="23tgr24aun1qy">
          <span className="font-[Figtree] text-2xl font-bold text-evergreen" style={{
          fontSize: size * 0.28
        }} data-id="element-2564" data-mp="1yvnjp7xt81p3">
            {clamped}
          </span>
          <span className="text-[10px] text-slate-400" data-id="element-2565" data-mp="28m9umoul041g">/100</span>
        </div>
      </div>
    </div>;
}